"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyProvider = exports.CurrencyContext = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _global = _interopRequireDefault(require("global"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CurrencyContext = exports.CurrencyContext = /*#__PURE__*/_react["default"].createContext();
var CurrencyProvider = exports.CurrencyProvider = function CurrencyProvider(props) {
  var _window$localStorage;
  var _useState = (0, _react.useState)(_global["default"] === null || _global["default"] === void 0 || (_window$localStorage = _global["default"].localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.currency),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currency = _useState2[0],
    setCurrency = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    rates = _useState4[0],
    setRates = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    creditCardCharges = _useState6[0],
    setCreditCardCharges = _useState6[1];
  (0, _react.useEffect)(function () {
    fetchRates();
  }, [fetchRates]);
  var fetchRates = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _window$localStorage2, _yield$fetch$then, data, _rates, userCurrency, _data$creditCardCharg, _creditCardCharges;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch('/api/fxrates').then(function (r) {
            return r.json();
          });
        case 3:
          _yield$fetch$then = _context.sent;
          data = _yield$fetch$then.data;
          _rates = data.rates, userCurrency = data.userCurrency, _data$creditCardCharg = data.creditCardCharges, _creditCardCharges = _data$creditCardCharg === void 0 ? {} : _data$creditCardCharg;
          _global["default"].localStorage.rates = JSON.stringify(_rates);
          _global["default"].localStorage.creditCardCharges = JSON.stringify(_creditCardCharges);
          setRates(_rates);
          setCreditCardCharges(_creditCardCharges);
          if (!(_global["default"] !== null && _global["default"] !== void 0 && (_window$localStorage2 = _global["default"].localStorage) !== null && _window$localStorage2 !== void 0 && _window$localStorage2.currency) && userCurrency) {
            changeCurrency(userCurrency);
          }
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          console.log({
            e: _context.t0
          });
          console.warn('Couldnt set fx rates from localStorage');
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  })), []);
  var changeCurrency = function changeCurrency(currency) {
    try {
      _global["default"].localStorage.currency = currency;
    } catch (e) {
      //
    }
    setCurrency(currency);
  };
  return /*#__PURE__*/_react["default"].createElement(CurrencyContext.Provider, {
    value: {
      currency: currency,
      rates: rates,
      creditCardCharges: creditCardCharges,
      changeCurrency: changeCurrency
    }
  }, props.children);
};